import { APIService } from 'connectors/api/rest';

export const Users = {
  async getList(params) {
    try {
      return await APIService.GET('users', params);
    } catch (e) {
      return null;
    }
  },
};
